import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@nextui-org/react";
import { useState } from "react";
import { Dialog } from 'primereact/dialog';
import apiurl from "../../services/apiendpoint/apiendpoint";

/* eslint-disable react/prop-types */
export default function DataTable(props) {
    const { data, handleStatusChange, editform, confirm2 } = props;
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState({ type: '', url: '', title: '' });

    const handleDropdownChange = (id, event) => {
        const newStatus = event.target.value;
        handleStatusChange(id, newStatus);
    };

    const openModal = (type, relativePath, title) => {
        const fullUrl = `${apiurl()}/${relativePath}`;
        setModalContent({ type, url: fullUrl, title });
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
        setModalContent({ type: '', url: '', title: '' });
    };

    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const renderModalContent = () => {
        const { type, url } = modalContent;
        const extension = getFileExtension(url);

        if (type === 'image' || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
            return (
                <img src={url} alt="Profile" className="max-w-full max-h-[80vh] object-contain"/>
            );
        } else if (type === 'document' || extension === 'pdf') {
            return (
                <div className="w-full h-[80vh]">
                    <iframe src={url} className="w-full h-full border-0" title="Document Viewer"/>
                </div>
            );
        } else {
            return (
                <div className="p-4 text-center">
                    <p className="text-gray-600">Cannot preview this file type</p>
                </div>
            );
        }
    };

    return (
        <>
            <div className="overflow-auto bg-white border rounded-xl h-[400px] xl:h-[500px] 2xl:h-[700px] my-5">
                <table className="min-w-full divide-y divide-gray-200 rounded-xl">
                    <thead>
                        <tr>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">S.No.</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Full Name</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">DoB</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Gender</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Address</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">City</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Pincode</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Community</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Father Name</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Occupation</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Mobile Number</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Alternative Number</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Email Address</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Educational Qualification</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Name of the college</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">How you know</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Others:(Details)</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Preferred Exam</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Profile Image</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Aadhar Card</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Application Status</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {data?.resdata?.map((item, index) => (
                            <tr key={index}>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{index + 1}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Full_name}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Dob}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Gender}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Address}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.City}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Pincode}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Community}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Father_Name}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Occupation}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Mobile_Number}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Alternative_Number}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Email}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Educational_Qualification}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.College_Name}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.how_you_know}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.how_you_know_others || '-'}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.preferred_exam}</td>
                                
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    {item.ProfileImage ? (
                                        <button
                                            onClick={() => openModal('image', item.ProfileImage, `${item.Full_name} - Profile Image`)}
                                            className="text-blue-500 transition-colors hover:text-blue-700"
                                            title="View Profile Image"
                                        >
                                            <i className="text-lg fi fi-rr-eye"></i>
                                        </button>
                                    ) : (
                                        <span className="text-gray-400">No Image</span>
                                    )}
                                </td>

                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    {item.Aadhar_card ? (
                                        <button
                                            onClick={() => openModal('document', item.Aadhar_card, `${item.Full_name} - Aadhar Card`)}
                                            className="text-blue-500 transition-colors hover:text-blue-700"
                                            title="View Aadhar Card"
                                        >
                                            <i className="text-lg fi fi-rr-eye"></i>
                                        </button>
                                    ) : (
                                        <span className="text-gray-400">No Document</span>
                                    )}
                                </td>

                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    <select 
                                        value={item.Application_Status || "not verified"} 
                                        onChange={(e) => handleDropdownChange(item._id, e)}
                                        className="px-2 py-1 border rounded"
                                    >
                                        <option value="not verified">Not Verified</option>
                                        <option value="verified">Verified</option>
                                    </select>
                                </td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    <Dropdown>
                                        <DropdownTrigger>
                                            <i className="text-lg cursor-pointer fi fi-rr-menu-dots-vertical"></i>
                                        </DropdownTrigger>
                                        <DropdownMenu aria-label="Dynamic Actions">
                                            <DropdownItem onPress={() => editform(item)} color={"default"}>
                                                Edit
                                            </DropdownItem>
                                            <DropdownItem onPress={() => confirm2(item._id)} color={"danger"} className={"text-danger"}>
                                                Delete
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Dialog header={modalContent.title} visible={modalVisible} onHide={closeModal} style={{ width: '80vw', maxWidth: '900px' }} breakpoints={{ '960px': '90vw', '641px': '95vw' }}
                modal draggable={false} resizable={false} maximizable
                contentStyle={{ padding: '1rem', maxHeight: '70vh', overflow: 'auto' }}
            >
                {renderModalContent()}
            </Dialog>
        </>
    );
}